import React from "react";
import classnames from 'classnames';
import PropTypes from "prop-types";
import { ENTER } from "../../../constants/keyboardCodes";
import Spinner from '../Spinner';

const ToggleSwitch = ({ checked, onChange, optionLabels, isDisabled }) => {
    const handleKeyPress = (e) => {
        if (e.keyCode !== ENTER) return;
        e.preventDefault();
        onChange(!checked);
    };
    return isDisabled ? <Spinner /> : (
        <div className={classnames("toggle-switch", { disabled: isDisabled })}>
            <input
                tabIndex={0}
                type="checkbox"
                className="toggle-switch-checkbox"
                checked={checked}
                onChange={e => { onChange(e.target.checked); }}
            />
            <div
                aria-label="toggle button"
                onClick={() => { onChange(!checked); }}
                className="toggle-switch-label"
                tabIndex={0}
                role="button"
                onKeyDown={e => handleKeyPress(e)}
            >
                <div
                    className={`toggle-switch-inner ${checked ? 'is-checked' : ''}`}
                >
                    <span className="label">{checked ? optionLabels[0] : optionLabels[1]}</span>
                </div>
                <span className="toggle-switch-switch" />
            </div>
        </div>
    );
};


ToggleSwitch.propTypes = {
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    optionLabels: PropTypes.array,
    isDisabled: PropTypes.bool,
};

ToggleSwitch.defaultProps = {
    optionLabels: ["ON", "OFF"],
    isDisabled: false,
};
export default ToggleSwitch;
